module.exports = __webpack_public_path__ + "img/battery_3disable.ccd7192a.png";